import { render, staticRenderFns } from "./teamCardList.vue?vue&type=template&id=da522ff4&scoped=true&"
import script from "./teamCardList.vue?vue&type=script&lang=js&"
export * from "./teamCardList.vue?vue&type=script&lang=js&"
import style0 from "./teamCardList.vue?vue&type=style&index=0&id=da522ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da522ff4",
  null
  
)

export default component.exports